module.exports = __webpack_public_path__ + "img/926.2e06cf70.png";